import React, { useState } from "react";

// useConnection
import { useSmartObject } from "@eveworld/contexts";

const WelcomePlayer = React.memo(() => {
  const { smartCharacter } = useSmartObject();
  // useConnection();

  if (smartCharacter === undefined) return <></>;
  if (smartCharacter.name === "") return <></>;

  const [welcomeMessage, setState] = useState(
    "Welcome " + smartCharacter.name + ", to Head Hunters!"
  );

  return (
    <>
      <div
        className="Quantum-Container font-semibold grid grid-cols-1 gap-2"
        id="SmartObject-Actions"
      >
        <div className="font-normal !py-4 text-center" id="error-message">
          {welcomeMessage}
        </div>
      </div>

      <div
        className="Quantum-Container font-normal text-xs !py-4"
        id="instructions-description"
      >
        Points are awarded for Strangers Heads, which can be dropped by NPC
        rats. Once you have deposited your heads into the inventory, click on
        Claim Points. Make sure to keep on playing and charge up the leader
        board!
      </div>
    </>
  );
});

export default React.memo(WelcomePlayer);
